import {HelpdeskTicker} from "./HelpdeskTicker";
import {HiringTicker} from "./HiringTicker";
import {DispatchTicker} from "./DispatchTicker";

const Tickers =  {
	HelpdeskTicker,
	HiringTicker,
	DispatchTicker
};

export default Tickers;
